import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: auto;
  flex: 1;
  padding: 1rem;
  box-sizing: border-box;
`;

export const Title = styled.div`
  text-align: center;
  color: #ffffff;
  font-weight: 700;
  font-size: 1rem;
  line-height: 2rem;
  letter-spacing: -3%;
  margin-bottom: 1rem;
`;

export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  color: #ffffff;
`;

export const ResultTitle = styled.div`
  color: #ffffff;
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 2rem;
  letter-spacing: -3%;
  margin-bottom: 1rem;
`;

export const ResultText = styled.div`
  color: #ffffff;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.8rem;
  letter-spacing: -3%;
  margin-bottom: 1rem;
  white-space: pre-wrap;
  word-break: keep-all;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  padding: 0.75rem 1.5rem;
  box-sizing: border-box;
`;

export const Button = styled.button`
  width: 100%;
  flex: 1;
  padding: 1rem 0;
  background-color: #0e0e11;
  color: #fff;
  border: none;
  border-radius: 3.5rem;
  font-family: "SUIT-Regular";
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

export const DontKnowPhoneNumberText = styled.div`
  width: 100%;
  padding: 0 1rem;
  color: #bfb9e7;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.125rem;

  font-size: 16px;
  line-height: 1.25rem;
`;

export const ChevronRightIconImg = styled.img`
  height: 0.875rem;
`;
